import { TASK_INSTANCES_KNOWN_FILTERS } from '../../constants';

export default function getKnownFilters(filters) {
  return Object.keys(filters)
    .filter((key) => TASK_INSTANCES_KNOWN_FILTERS.includes(key))
    .reduce(
      (acc, filterKey) => ({
        ...acc,
        [filterKey]: filters[filterKey],
      }),
      {}
    );
}
